import React, { useEffect, useState } from "react";
import { useParams, useNavigate,useLocation } from "react-router-dom";
import Likes from "../../components/likes/Likes";
import Comments from "../../components/comment/Comments";
import axios from 'axios'
const SERVER = `https://volunteer-server.onrender.com`
//const SERVER = `http://localhost:8800`
const Replies = (props) => {
    const [replyList, setReplyList] = useState([]);
    const [reply, setReply] = useState("");
    const [message,setMessage] = useState("")
    //const [title, setTitle] = useState("");
    const {state} = useLocation();
    const navigate = useNavigate();
    const { id } = useParams();
    const [thread, setThread] = useState("");
    useEffect(() => {
        const fetchReplies = () => {
            fetch(`${SERVER}/api/thread/replies`, {
                method: "POST",
                body: JSON.stringify({
                    id,
                }),
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then((res) => res.json())
                .then((data) => {
                    setReplyList(data);
                    
                })
                .catch((err) => console.error(err));
        };
        const fetchComment = () => {
            fetch(`${SERVER}/api/getcomment`, {
                method: "POST",
                body: JSON.stringify({
                    id
                }),
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then((res) => res.json())
                .then((message) => {
                    setMessage(message.message);
                    
                })
                .catch((err) => console.error(err));
        };
        fetchComment();
        fetchReplies();
    }, [id]);

    const getLikes = async(id)=>{
        try{
            const res = await axios.post(`${SERVER}/api/thread/replylikes`,{forumId:id})
            
            return res.data.likes
        }catch(e){
            console.log(e)
        }
    }

    const addReply = () => {
        fetch(`${SERVER}/api/create/reply`, {
            method: "POST",
            body: JSON.stringify({
                id,
                userId: JSON.parse(localStorage.getItem("user")).ID_user,
                text:reply,
                email:JSON.parse(localStorage.getItem("user")).email
            }),
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((data) => {
                alert(data.message);
                navigate("/forum");
            })
            .catch((err) => console.error(err));
    };
    //👇🏻 This function when triggered when we add a new reply
    const handleSubmitReply = (e) => {
        e.preventDefault();
        //👇🏻 calls the function
        addReply();
        setReply("");
    };
    const getComments = async(id)=>{
        try{
            const res = await axios.post(`${SERVER}/api/thread/comments`,{forumId:id})
            
            return res.data.comments
        }catch(e){
            console.log(e)
        }
    }
    return (
        <main className='replies'>
        <h1 className='repliesTitle'>{message}</h1>
        { JSON.parse(localStorage.getItem("user")).ID_user ? 
        <form className='modal__content' onSubmit={handleSubmitReply}>
            <label htmlFor='reply'>Відповісти на повідомлення</label>
            <textarea
                rows={5}
                value={reply}
                onChange={(e) => setReply(e.target.value)}
                type='text'
                name='reply'
                className='modalInput'
            />

            <button className='modalBtn'>Надіслати</button>
        </form>
: "COMMENTS"}
        <div className='thread__container'>
            {replyList.map((reply) => (
                <div className='thread__item'>
                    <p>{reply.text}</p>
                    <div className='react__container'>
                    <Likes getLikes={getLikes} threadId={reply.idreplies} category={'replies'}/>
                    {/* <Comments
                                    getComments={getComments}
                                    threadId={reply.idreplies}
                                    title={reply.message}
                                /> */}
                        <p style={{ opacity: "0.5" }}>by {reply.email.split("@")[0]}</p>
                    
                    </div>
                </div>
            ))}
        </div>
    </main>
    );
};

export default Replies;